import { useTranslation } from "react-i18next";
import { changeForError } from "@/lib/changeFor";

type Props = { value: string; onChange: (v: string) => void; amountDue: number; currency: string };

export function ChangeForField({ value, onChange, amountDue, currency }: Props) {
  const { t } = useTranslation();
  const error = changeForError(value, amountDue);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, padding: "12px 14px" }}>
      <label htmlFor="change-for" style={{ fontSize: 13, fontWeight: 600, color: "var(--ink-1)" }}>
        {t("v2.checkout.change_for_label", { currency, defaultValue: `Change for (${currency})` })}
      </label>
      <input
        id="change-for"
        data-testid="change-for-input"
        inputMode="decimal"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("v2.checkout.change_for_placeholder", "Leave empty if you have the exact amount")}
        aria-invalid={error ? true : undefined}
        style={{ padding: "10px 12px", borderRadius: 10, border: "1px solid var(--border)", fontSize: 15 }}
      />
      {error && (
        <span data-testid="change-for-error" role="alert" style={{ fontSize: 12, color: "var(--danger-600)" }}>
          {error === "too_low"
            ? t("v2.checkout.change_for_too_low", "Enter an amount equal to or above your total")
            : t("v2.checkout.change_for_invalid", "Enter a number, for example 200")}
        </span>
      )}
    </div>
  );
}
